<div class="body">
  <div class="container mt-4">
    <div class="title-box">
      <h3>
        Crear nuevo <span class="txtbienvenida-2">lugar de atención</span>
      </h3>
    </div>
    <div class="container mt-4">
      <form [formGroup]="lugaresAtencionForm" (ngSubmit)="guardarLugares()">
        <div class="row myForm">
          <div class="col-sm-12 col-md-6 col-lg-6 col-xs-12">
            <div class="mb-3 required form-label">
              <label for="idDepartamento" class="form-label">Departamento de Atención</label>
              <select #dept class="form-control selectpicker" data-size="3" data-live-search="true"
                formControlName="idDepartamento" (change)="getCiudades(dept.value)" title="Seleccione..." required>
                @for (dp of departamentos; track dp) {
                  <option [value]="dp.idDepartamento">
                    {{ dp.nombreDepartamento | uppercase }}
                  </option>
                }
              </select>
              <div class="invalid-feedback">Campo obligatorio</div>
            </div>
          </div>
          <div class="col-sm-12 col-lg-6 col-md-6 col-xs-12 mt-2 p-2">
            <div class="form-check form-switch d-inline-flex align-items-center gap-2">
              <input class="form-check-input" type="checkbox"
                role="switch" (click)="actualizarCiudades()"
                formControlName="aplicaTodasCiudades"
                id="customSwitch1" aria-checked="false"/>
                <label class="form-check-label" for="customSwitch1">Aplica para todas las ciudades</label>
              </div>
            </div>
          </div>
          <div class="row myForm" [hidden]="lugaresAtencionForm.get('aplicaTodasCiudades').value !== false">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12 mt-3">
              <div class="mb-3 required form-label">
                <label for="ciudades" class="form-label">Ciudades de Atención</label>
                <select #ciud id="ciud" data-live-search="true" data-size="5" formControlName="ciudades"
                  class="form-control selectpicker" title="Seleccione..." multiple
                  [required]="!lugaresAtencionForm.controls.aplicaTodasCiudades.value">
                  @for (cd of ciudades; track cd) {
                    <option [value]="cd.idCiudad">
                      {{ cd.nombreCiudad | uppercase }}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">Campo obligatorio</div>
              </div>
            </div>
          </div>

          <div class="row justify-content-md-center g-3">
            <div class="col-12 col-md-2 container-btn">
              <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;"
                [disabled]="!lugaresAtencionForm.valid">
                Crear
              </button>
            </div>
            <div class="col-12 col-md-2 container-btn">
              <button type="button" class="btn btn-primary hvr-shrink" style="width: 180px;"
                [routerLink]="['/intermediario/administracion/ubicaciones']">
                Volver
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    @if (isError) {
      <div class="alert alert-danger alert-dismissible fade show" role="alert">
        Hay una ciudad que intenta guardar que ya tiene registrada
        <button type="button" (click)="isError = false" class="close" data-bs-dismiss="alert" aria-label="Close">
        </button>
      </div>
    }
    <div class="footer-body"></div>
  </div>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
